<template>
	<VerticalLayout>
		<Space v-for="(point, index) in modelValueRef" :key="index">
			<InputDecimal class="js-lat-input" v-model="point.lat" :placeholder="$t('pointsDisplay.latitude')" :disabled="disabled" range="latitude" />
			<InputDecimal v-model="point.lon" :placeholder="$t('pointsDisplay.longitude')" :disabled="disabled" />
			<Tooltip :title="$t('pointsDisplay.removePoint')">
				<Button size="small" shape="circle" @click="removePoint(index)" :disabled="disabled">
					<template #icon>
						<CloseOutlined />
					</template>
				</Button>
			</Tooltip>
		</Space>
		<Button @click="addPoint" :disabled="disabled">
			<PlusCircleOutlined /> {{ $t('pointsDisplay.addPoint') }}
		</Button>
	</VerticalLayout>
</template>

<script>
import { ref, nextTick } from 'vue';
import { useVModel } from '@vueuse/core';
import { Button, Space, Tooltip } from 'ant-design-vue';
import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';

import VerticalLayout from '@/components/common/VerticalLayout.vue';
import InputDecimal from '@/components/common/InputDecimal.vue';

export default {
	name: 'PointsDisplay',
	components: {
		Button, Space, Tooltip,
		CloseOutlined, PlusCircleOutlined,
		VerticalLayout, InputDecimal,
	},
	props: {
		modelValue: {
			type: Array,
			default: () => [],
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const latInputs = ref([]);
		const modelValueRef = useVModel(props, 'modelValue', emit);
		const addPoint = () => {
			modelValueRef.value = [...modelValueRef.value, { lat: '', lon: '' }];
			nextTick(() => {
				const latInputs = document.querySelectorAll('.js-lat-input');
				if (latInputs.length > 0) {
					const lastInput = latInputs[latInputs.length - 1];
					if (lastInput) {
						lastInput.focus();
					}
				}
			});
		};
		const removePoint = index => {
			const newPoints = [...props.modelValue];
			newPoints.splice(index, 1);
			modelValueRef.value = newPoints;
		};
		return {
			latInputs,
			modelValueRef,
			addPoint,
			removePoint,
		};
	},
};
</script>

